<template>
  <span :title="$t(isClosed ? 'Закрытая процедура' : 'Открытая процедура')">
    <v-icon
        class="ml-1"
        style="font-size: 24px"
        :icon="titleIcon"
    />
  </span>
</template>

<script>
export default {
  name: 'OpenCloseIconInfo',
  props: {
    isClosed: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    titleIcon() {
      return 'custom:' + (this.isClosed ? 'closedLockIcon' : 'openLockIcon');
    }
  },
}
</script>